<template>
	<div class="table-form-results">

		<div class="has-forms" v-if="formResults && formResults.length > 0">
			<div class="the-table">
				<div class="headers">
					<div class="row">
						<span>Name</span>
						<span>Submit Date</span>
						<span>Author</span>
						<span>Completed</span>
						<span></span>
					</div>
				</div>
				<div class="table">
					<div 
						class="row"
						v-for="(result, index) in formResults"
						:key="index"
						>
						<span 
							v-html="`${result.form_name} ${result.week != null ? ` <div class='week-pill'>${result.week} Week</div>` : '' }`" 
							/>
						<span>
							{{ result.completed ? formatDate(result.created_at) : `Last edited: ${formatDate(result.updated_at)}` }}
						</span>
						<span>
							{{ result.user.name }}
						</span>
						<span>
							<div 
								class="active-dot" 
								:class="result.completed ? 'active' : 'inactive'"
								/>
						</span>
						<span class="action-buttons">

							<template v-if="result.uploads.length > 0">
								<a 
									v-if="result.uploads[0].is_available"
									:href="`/download/${base64Encode(result.uploads[0].id)}/${result.id}`"
									>
									<Button
										label="Download"
										icon="download"
										color="blue"
										/>
								</a>
								<Button
									v-else
									label="File processing..."
									color="red"
									/>
							</template>

							<template v-else>
								<Button
									icon="file-pdf"
									color="blue"
									@click="downloadPDF(result)"
									/>
								
								<a :href="`/cases/${caseHash}/download-form-submission-json/${result.id}`">
									<Button
										label="JSON"
										color="blue"
										/>
								</a>

								<a :href="`/cases/${caseHash}/form-submissions/${result.id}`">
									<Button
										label="View"
										color="green"
										/>
								</a>
							</template>

							<Button
								label="Logs"
								color="dark"
								:buttonRoute="`/cases/${caseHash}/form-audit-logs/${result.id}`"
								/>

						</span>
					</div>
				</div>
			</div>

		</div>

		<div class="empty-results" v-else>
			<Placeholder 
				message="No forms have been submitted."
				/>
		</div>

	</div>
</template>

<script>

import moment from 'moment'
import axios from 'axios'

import Placeholder from "@/Components/Placeholder"
import Button from "@/Components/Button"

import { setLicenseKey } from "survey-core"
import { SurveyPDF } from 'survey-pdf'

export default {
	components: {
		Placeholder,
		Button
	},
	props: {
		formResults: [Array, Object],
		caseHash: {
			type: String,
			required: true
		},
		surveyJSKey: {
			type: String,
			required: true
		},
		case: {
			type: Object,
			required: true
		}
	},
	data: () => {
		return {
			
		}
	},
	mounted(){
		// console.log('surveyJSKey', this.surveyJSKey)

		setLicenseKey(
			this.surveyJSKey
		)
	},
	methods: {
		formatDate(date) {
			return moment(date).format('DD/MM/YYYY HH:mm')
		},
		downloadPDF(formResult){
			setLicenseKey(
				this.surveyJSKey
			)

			let pages = formResult.form_schema.pages
			let surveyJson = []
			pages.forEach(page => {
				surveyJson = surveyJson.concat(page.elements)
			})

			surveyJson = {
				elements: surveyJson,
				logo: 'data:image/png;base64,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',
				logoPosition: 'left',
				logoWidth: 107,
				logoHeight: 105,
				logoFit: 'contain',
			}

			const pdfDocOptions = {
				fontSize: 12,
				margins: {
					top: 5,
					bottom: 15,
					left: 15,
					right: 15
				},
			}

			console.log('pdf maker', {
				surveyJson, 
				pdfDocOptions,
				results: formResult.result_data,
				formResult: formResult,
				case: this.case
			})

			// process formResult.created_at to YYYYMMDDhhmm from "2024-04-26T14:19:25.000000Z" format
			const created_at = new Date(formResult.created_at)
			const created_at_string_filename = `${created_at.getFullYear()}${(created_at.getMonth() + 1).toString().padStart(2, '0')}${created_at.getDate().toString().padStart(2, '0')}${created_at.getHours().toString().padStart(2, '0')}${created_at.getMinutes().toString().padStart(2, '0')}`

			// format another date for the header to look like "26th April 2024 at 15:19"
			const created_at_string_header = `${created_at.getDate().toString().padStart(2, '0')}th ${created_at.toLocaleString('default', { month: 'long' })} ${created_at.getFullYear()} at ${created_at.getHours().toString().padStart(2, '0')}:${created_at.getMinutes().toString().padStart(2, '0')}`

			const surveyPdf = new SurveyPDF(surveyJson, pdfDocOptions);
			surveyPdf.data = formResult.result_data;
			surveyPdf.onRenderHeader.add((_, canvas) => {
				if (canvas.pageNumber === 1) {
					canvas.drawText({
						text: formResult.form_name,
						fontSize: 11,
						isBold: true,
						margins: { top: 40, left: 135 },
						horizontalAlign: "left",
					});
					canvas.drawText({
						text: `Completed by: ${formResult.user.name} <${formResult.user.email}> on: ${created_at_string_header}`,
						fontSize: 9,
						isBold: false,
						margins: { top: 70, left: 135 },
						horizontalAlign: "left",
					});
					canvas.drawText({
						text: this.case.enquiry_number ? `Enquiry Number: ${this.case.enquiry_number}` : `Case ID: ${this.case.hashid}`,
						fontSize: 9,
						isBold: false,
						margins: { top: 100, left: 135 },
						horizontalAlign: "left",
					});
					canvas.drawText({
						text: `Patient Reference: ${this.case.patient_reference ? this.case.patient_reference : 'N/A'}`,
						fontSize: 9,
						isBold: false,
						margins: { top: 130, left: 135 },
						horizontalAlign: "left",
					});
					if(formResult.week != null){
						canvas.drawText({
							text: `Week: ${formResult.week}`,
							fontSize: 9,
							isBold: false,
							margins: { top: 160, left: 135 },
							horizontalAlign: "left",
						});
					}
				}
			});
			surveyPdf.onRenderFooter.add((_, canvas) => {
				canvas.drawText({
					text: "Page " + canvas.pageNumber + " of " + canvas.pageCount,
					horizontalAlign: "right",
					verticalAlign: "bottom",
					fontSize: 11,
					margins: {
						right: 12,
						bot: 12
					}
				});
			});

			// surveyPdf.onRenderPage.add(function(sender, options) {
			// 	if (options.pageNumber > 1) {
			// 		// Change the margins for subsequent pages
			// 		options.pdf.setPageMargins(15, 15, 15, 15);
			// 	}
			// });
			
			// Define the filename
			const orderNumber = this.case.enquiry_number ? `${this.case.enquiry_number}_` : ''; // it used to be enquiry number, then they changed it. screw changing the database over this.

			const filename = `${orderNumber}${this.sluggify(formResult.form_name)}_${created_at_string_filename}.pdf`;

			// Save the PDF with the specified filename
			surveyPdf.save(filename);

			// send a request to set an audit log for the pdf download
			axios.post(`/cases/${this.caseHash}/notify-pdf-download/${formResult.id}`)
				.then(response => {
					// handle success
					// console.log(response.data);
				})
				.catch(error => {
					// handle error
					console.log(error)
				})
		},
		base64Encode(string){
			let value = String(string)
			if (process.client) {
				return window.btoa(unescape(encodeURIComponent(value)))
			} else {
				return Buffer.from(value, 'ascii').toString('base64')
			}
		},
		sluggify(string){
			return string.toLowerCase().replace(/[^a-z0-9]/g, '-')
		}
	},
	computed: {
		
	},
}
</script>

<style lang="sass">

.table-form-results
	width: 100%
	display: flex
	flex-direction: column
	margin-bottom: 30px

	.has-forms
		display: flex
		flex-direction: column
		gap: 20px
		margin-bottom: 20px

	.the-table
		.headers
			font-size: 18px
			font-weight: 700
			font-family: 'Roboto Condensed', sans-serif
			color: #252525
			line-height: 1.1
			margin-bottom: 10px

			.row
				padding: 0 20px

		.row
			display: grid
			grid-template-columns: 1fr 0.5fr 0.5fr 0.3fr 260px
			gap: 10px

			.week-pill
				margin-left: 10px
				padding: 3px 5px
				border-radius: 8px
				background-color: #e8e8e8
				border: 1px solid #c8c8c8
				font-size: 12px
				font-family: 'Roboto Condensed', sans-serif
				color: #252525
				font-weight: 700
				line-height: 1

			span
				display: flex
				align-items: center

				&:last-child
					justify-content: flex-end

				&.action-buttons
					display: flex
					gap: 5px

			.active-dot
				width: 15px
				height: 15px
				border-radius: 50%
				background-color: #d00
				transition: all 300ms

				&.active
					background-color: #0d0

		@media (max-width: 900px)
			overflow-x: auto
			
			.row
				// display: flex

				span
					min-width: 190px

		.table
			width: 100%
			background-color: #fff
			border-radius: 8px
			box-shadow: 0 1px 3px rgba(#000, 0.12)
			padding: 0 20px

			.row
				font-size: 16px
				font-weight: 400
				font-family: 'Roboto', sans-serif
				color: #252525
				line-height: 1.1
				height: 60px
				border-bottom: 1px solid #d0d0d0
				align-items: center

				&:last-child
					border-bottom: none


	.buttons
		margin-top: 20px
		display: flex
		gap: 10px

	

</style>
